import { ConsolePageModalFooterContainer } from "./styles";

interface IConsolePageModalFooterProps {
  children: React.ReactNode;
}

export const ConsolePageModalFooter = ({
  children,
}: IConsolePageModalFooterProps) => {
  return (
    <ConsolePageModalFooterContainer>
      {children}
    </ConsolePageModalFooterContainer>
  );
};
